(function () {
  function money(cents) {
    var n = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return '€' + n;
  }
  function fc() {
    return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
  }
  var cache = {};
  // Producten die NOOIT als aanbeveling mogen verschijnen (bv. 1-liter b2b-formaten)
  function blocked(p) {
    return /(1000\s*ml|1\s*liter|1\s*l\b)/i.test(p.title || '');
  }

  function wrap() { return document.getElementById('rm-cart-upsell'); }
  function list() { return document.getElementById('rm-cart-upsell-list'); }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function cardHTML(p) {
    var img = p.featured_image || p.image || '';
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var price = onSale
      ? '<s class="rm-up-was">' + money(p.compare_at_price) + '</s><span class="rm-up-now">' + money(p.price) + '</span>'
      : '<span>' + money(p.price) + '</span>';
    var single = p.variants && p.variants.length === 1 && p.variants[0] && p.variants[0].available;
    var action = single
      ? '<button type="button" class="rm-up-btn" data-rm-add="' + p.variants[0].id + '">Toevoegen</button>'
      : '<a class="rm-up-btn" href="' + esc(p.url) + '">Bekijken</a>';
    var thumb = img
      ? '<div class="rm-up-thumb"><img src="' + esc(img) + '" alt="" loading="lazy"></div>'
      : '<div class="rm-up-thumb"></div>';
    return '<div class="rm-up-card">' + thumb +
      '<div class="rm-up-info"><div class="rm-up-title">' + esc(p.title) + '</div>' +
      '<div class="rm-up-price-row">' + price + '</div></div>' + action + '</div>';
  }

  function render(products) {
    var w = wrap(), l = list();
    if (!w || !l) return;
    var exclude = (w.getAttribute('data-cart-products') || '').split(',').filter(Boolean);
    var items = (products || []).filter(function (p) {
      return exclude.indexOf(String(p.id)) === -1 && !blocked(p);
    }).slice(0, 3);
    if (!items.length) { w.hidden = true; l.innerHTML = ''; return; }
    l.innerHTML = items.map(cardHTML).join('');
    w.hidden = false;
    var btns = l.querySelectorAll('[data-rm-add]');
    for (var i = 0; i < btns.length; i++) btns[i].addEventListener('click', onAdd);
  }

  function onAdd(e) {
    var btn = e.currentTarget;
    var id = btn.getAttribute('data-rm-add');
    btn.disabled = true;
    btn.textContent = 'Toegevoegd';
    var cd = document.querySelector('cart-drawer');
    var addUrl = (window.routes && routes.cart_add_url) || '/cart/add';
    var cfg = fc();
    cfg.body = JSON.stringify({
      items: [{ id: Number(id), quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    });
    fetch(addUrl, cfg)
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (cd && typeof cd.renderContents === 'function') { cd.renderContents(state); }
        else { window.location = (window.routes && routes.cart_url) || '/cart'; }
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Toevoegen'; });
  }

  function refresh() {
    var w = wrap(), l = list();
    if (!w || !l) return;
    if (l.children.length) return;
    var base = w.getAttribute('data-base');
    if (!base) { w.hidden = true; return; }
    if (cache[base]) { render(cache[base]); return; }
    var rurl = (window.routes && routes.product_recommendations_url) || '/recommendations/products';
    fetch(rurl + '.json?product_id=' + base + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) { cache[base] = (d && d.products) || []; render(cache[base]); })
      .catch(function () { w.hidden = true; });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(refresh, 140); }

  function init() {
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      var target = document.getElementById('CartDrawer') || cd;
      try { new MutationObserver(schedule).observe(target, { childList: true, subtree: true }); } catch (e) {}
    }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
